var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3cb5ea;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(307 401)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314 411.92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.609 1.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M359.533,101.721,352.211,109l7.322,7.275a2.1,2.1,0,0,0,.213-.909V102.63A2.1,2.1,0,0,0,359.533,101.721Z",
    transform: "translate(-352.211 -101.721)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.213 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.53,76H26.63a2.1,2.1,0,0,0-.909.213l9.359,9.311a2.124,2.124,0,0,0,3,0l9.359-9.311A2.1,2.1,0,0,0,46.53,76Z",
    transform: "translate(-25.721 -76)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.213,101.721A2.1,2.1,0,0,0,0,102.63v12.732a2.1,2.1,0,0,0,.213.909L7.535,109Z",
    transform: "translate(0 -101.721)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.213 9.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.116,277.211l-1.036,1.036a3.54,3.54,0,0,1-5,0l-1.036-1.036-7.322,7.275a2.1,2.1,0,0,0,.909.213h19.9a2.1,2.1,0,0,0,.909-.213Z",
    transform: "translate(-25.721 -277.211)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.babe2bff971c0224ca61819f94182fc6.svg";
export { ForwardRef as ReactComponent };